import type { TabsItem } from '@nuxt/ui'

interface UseDetailTabsOptions {
  tabs: NonNullable<TabsItem[]>
  basePath: string
  paramName?: string
  rootTabValue?: string
}

export function useDetailTabs(options: UseDetailTabsOptions) {
  const route = useRoute()
  const router = useRouter()

  const { tabs, basePath, paramName = 'id', rootTabValue = 'index' } = options

  const activeTab = computed({
    get() {
      const currentPathEnd = route.path.replace(/\/$/, '').split('/').pop()

      if (currentPathEnd === route.params[paramName]) {
        return rootTabValue
      }

      const foundTab = tabs.find((tab) => tab.value === currentPathEnd)
      return foundTab ? foundTab.value : rootTabValue
    },
    set(newTabValue: string) {
      if (newTabValue === rootTabValue) {
        router.push(`${basePath}/${route.params[paramName]}`)
      } else {
        router.push(`${basePath}/${route.params[paramName]}/${newTabValue}`)
      }
    },
  })

  return { activeTab }
}
